module.exports = new __parcel__URL__("AdobeExperiencePlatform.6e79ef30.svg").toString();